import { library } from '@fortawesome/fontawesome-svg-core'
import { faLinkedin, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faUserCheck, faChevronRight, faPodcast } from '@fortawesome/free-solid-svg-icons'

library.add(faLinkedin, faEnvelope, faUserCheck, faChevronRight, faYoutube, faPodcast);